import { PRODUCT_LOANS } from '@/constants/products';
import { getRateChanges } from '@/graphql/queries/shared/rate-change';
import lang from '@/lang/middleware/products/banking/loans';

export default async ({ $apolloQuery, store }) => {
  await $apolloQuery(getRateChanges, { product: PRODUCT_LOANS }).then(rateChangeSet => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const description = store.$i18n.t('rate-changes.description');
    const subtitle = store.$i18n.t('rate-changes.subtitle');
    const title = store.$i18n.t('rate-changes.title');
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('pageContent/setHead', { description, title });
    store.commit('rateChanges/setMeta', rateChangeSet.data);
    store.commit('rateChanges/set', rateChangeSet.changes);
    store.commit('utils/setPagination', rateChangeSet.meta.pagination);
  });
};
